import myRequery from '/static/request.js'
import { prefix } from '/static/baseUrl'
/*登录接口
*/
export function userLogin(options) {
	return myRequery({
		url: 'api/user/login',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/*登录后修改密码*/
export function userChangePwd(options) {
	return myRequery({
		url: 'api/user/changepassword',
		method: 'PUT',
		prefix: prefix,
		data: options,
	})
}

/*忘记密码并修改*/
export function userForgetPwd(options) {
	return myRequery({
		url: 'api/user/forgot',
		method: 'PUT',
		prefix: prefix,
		data: options,
	})
}

/*获取短信验证码,登录和忘记密码用*/
export function getSmsCode(options) {
	return myRequery({
		url: 'api/user/getsmscode',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/*获取短信验证码,修改密码用*/
export function getSmsCodeChange(options) {
	return myRequery({
		url: 'api/user/getsmscode_change',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/************************************    优惠劵     *******************************/
/*优惠劵 - 查询优惠券列表
{
  "usrId": "string",
  "code": "string",
  "type": "string",
  "begin": "2024-10-08T09:29:12.922Z",
  "end": "2024-10-08T09:29:12.922Z"
}*/
export function queryCouponsLists(options) {
	return myRequery({
		url: 'api/Coupon/CouponsList',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}
/*优惠劵 - 发放优惠券
{
  "usrId": "string",
  "code": "string",
  "count": 0,
  "type": "string",
  "value": "string",
  "begintime": "2024-10-08 09:51:07",
  "overtime": "2024-10-08 09:51:07"
}*/
export function sendCoupons(options) {
	return myRequery({
		url: 'api/Coupon/DistributeCoupons',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/*得到新的优惠券编码*/
export function getCouponCode(options) {
	return myRequery({
		url: 'api/Coupon/getnewcode',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/*优惠劵 - 领用和使用优惠券列表
{
	"usrId": "",
	"code": "test-222",
	"state": "",
	"pageIndex": 1,
	"pageSize": 10
}*/
export function queryCouponsDetailList(options) {
	return myRequery({
		url: 'api/Coupon/DetailByCode',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/*优惠劵 - 暂停优惠劵
{
	"usrId": "",
	"code": "test-222"
}*/
export function stopCoupons(options) {
	return myRequery({
		url: 'api/Coupon/StopByCode',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/*优惠劵 - 删除优惠劵
{
	"usrId": "",
	"code": "test-222"
}*/
export function deleteCoupons(options) {
	return myRequery({
		url: 'api/Coupon/DeleteByCode',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

// 验证客户手机号
export function validateCustomer(options) {
	return myRequery({
		url: 'api/customercoupon/validatecustomer',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

// 添加客户优惠券
export function addCustomerCoupon(options) {
	return myRequery({
		url: 'api/customercoupon',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

// 查询客户优惠券
export function queryCustomerCouponsLists(options) {
	return myRequery({
		url: 'api/customercoupon',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

// 删除客户优惠券
export function deleteCustomerCoupon(options) {
	return myRequery({
		url: 'api/customercoupon',
		method: 'DELETE',
		prefix: prefix,
		data: options,
	})
}
/************************************    订单     *******************************/
/*订单 - 查询订单列表
{
  "usrId": "string",
  "code": "string",
  "type": "string",
  "begin": "2024-10-08T09:51:07.954Z",
  "end": "2024-10-08T09:51:07.954Z"
}*/
export function queryOrderLists(options) {
	return myRequery({
		url: 'api/Order/List',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/*订单 - 查询订单详情
{
  "usrId": "string",
  "orderNum": "string"
}*/
export function queryOrderDetail(options) {
	return myRequery({
		url: 'api/Order/DetailAndPay',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/*订单 - 查询订单时间轴
{
  "usrId": "string",
  "orderno": "string"
}*/
export function queryOrderTimeline(options) {
	return myRequery({
		url: 'api/Order/StatusTime',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/*订单 - 补打餐条
{
  "usrId": "string",
  "orderid": "string"
}*/
export function reprintOrderPaper(options) {
	return myRequery({
		url: 'api/Order/ReprintOrder',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/************************************    商家管理     *******************************/
/*商家 - 查询列表
{
  "name": "string",
  "state": "string",
  "isdeleted": "string",
  "offset": ,
  "limit": 
}*/
export function queryBusinessLists(options) {
	return myRequery({
		url: 'api/entrybusiness',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}
/*商家 - 查询详情
{
  "id": "string"
}*/
export function queryBusinessDetail(options) {
	return myRequery({
		url: 'api/entrybusiness/detail',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}
/*商家 - 添加商家
{
  "id": "string",
  "name": "string",
  "legalperson": "string",
  "phone": "string",
  "contactperson": "string",
  "businesslicense": "string",
  "state": "string",
  "jointime": "2024-10-08T09:57:05.862Z",
  "createtime": "2024-10-08T09:57:05.862Z",
  "createuser": "string",
  "isdeleted": "string"
}*/
export function addBusiness(options) {
	return myRequery({
		url: 'api/entrybusiness',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}
/*商家 - 修改商家信息
{
  "id": "string",
  "name": "string",
  "legalperson": "string",
  "phone": "string",
  "contactperson": "string",
  "businesslicense": "string",
  "state": "string",
  "jointime": "2024-10-08T09:56:46.827Z",
  "createtime": "2024-10-08T09:56:46.827Z",
  "createuser": "string",
  "isdeleted": "string"
}*/
export function editBusiness(options) {
	return myRequery({
		url: 'api/entrybusiness',
		method: 'PUT',
		prefix: prefix,
		data: options,
	})
}
/*商家 - 删除商家
{
  "ids": ["string"]
}*/
export function deleteBusiness(options) {
	return myRequery({
		url: 'api/entrybusiness',
		method: 'DELETE',
		prefix: prefix,
		data: options,
	})
}

// 启用/停用商家
export function ChangeBusinessState(options) {
	return myRequery({
		url: 'api/entrybusiness/changestate',
		method: 'PUT',
		prefix: prefix,
		data: options,
	})
}

// 查询档口
export function queryStallLists(options) {
	return myRequery({
		url: 'api/stall',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

// 得到档口详情
export function getStallDetail(options) {
	return myRequery({
		url: 'api/stall/detail',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

// 添加档口
export function addNewStall(options) {
	return myRequery({
		url: 'api/stall',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

// 编辑档口
export function editStall(options) {
	return myRequery({
		url: 'api/stall',
		method: 'PUT',
		prefix: prefix,
		data: options,
	})
}

// 删除档口
export function deleteStall(options) {
	return myRequery({
		url: 'api/stall',
		method: 'DELETE',
		prefix: prefix,
		data: options,
	})
}

// 启用/停用档口
export function ChangeStallState(options) {
	return myRequery({
		url: 'api/stall/changestate',
		method: 'PUT',
		prefix: prefix,
		data: options,
	})
}

// 查询商家用户
export function queryShopUserLists(options) {
	return myRequery({
		url: 'api/shopuser',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

// 得到商家用户详情
export function getShopUserDetail(options) {
	return myRequery({
		url: 'api/shopuser/detail',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

// 添加商家用户
export function addNewShopUser(options) {
	return myRequery({
		url: 'api/shopuser',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

// 编辑商家用户
export function editShopUser(options) {
	return myRequery({
		url: 'api/shopuser',
		method: 'PUT',
		prefix: prefix,
		data: options,
	})
}

// 删除商家用户
export function deleteShopUser(options) {
	return myRequery({
		url: 'api/shopuser',
		method: 'DELETE',
		prefix: prefix,
		data: options,
	})
}

// 启用/停用商家用户
export function ChangeShopUserState(options) {
	return myRequery({
		url: 'api/shopuser/changestate',
		method: 'PUT',
		prefix: prefix,
		data: options,
	})
}

// 查询系统配置
export function querySysConfigLists(options) {
	return myRequery({
		url: 'api/sysconfig',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

// 得到系统配置详情
export function getSysConfigDetail(options) {
	return myRequery({
		url: 'api/sysconfig/detail',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

// 添加系统配置
export function addNewSysConfig(options) {
	return myRequery({
		url: 'api/sysconfig',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

// 编辑系统配置
export function editSysConfig(options) {
	return myRequery({
		url: 'api/sysconfig',
		method: 'PUT',
		prefix: prefix,
		data: options,
	})
}

// 查询退款订单
export function queryRefundOrdersList(options) {
	return myRequery({
		url: 'api/orderman/refundorderlist',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

// 得到订单付款信息
export function queryRefundDetail(options) {
	return myRequery({
		url: 'api/orderman/getpayedinfo',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

// 取消订单
export function cancelOrder(options) {
	return myRequery({
		url: 'api/orderman/cancelorder',
		method: 'PUT',
		prefix: prefix,
		data: options,
	})
}

// 订单退款
export function refundOrder(options) {
	return myRequery({
		url: 'api/orderman/refund',
		method: 'PUT',
		prefix: prefix,
		data: options,
	})
}

// 导出退款订单
export function exportRefundOrderData(options) {
	return myRequery({
		url: 'api/orderman/export',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

// 关闭订单
export function closeOrder(options) {
	return myRequery({
		url: 'api/Order/CloseOrder',
		method: 'PUT',
		prefix: prefix,
		data: options,
	})
}

/*查询菜品分类*/
export function queryFoodCategroy(options) {
	return myRequery({
		url: 'api/foodcategory/list',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/*查询平台销售订单*/
export function queryOrderSaleList(options) {
	return myRequery({
		url: 'api/report/ordersalelist',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/*查询平台销售统计*/
export function queryPlatformSaleStat(options) {
	return myRequery({
		url: 'api/report/platformsalestat',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/*查询配送员订单*/
export function queryDeliveryDetailList(options) {
	return myRequery({
		url: 'api/report/deliverydetail',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/*查询配送员统计*/
export function queryDeliverySaleStat(options) {
	return myRequery({
		url: 'api/report/deliverysalestat',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/*导出平台统计明细*/
export function exportPlatformStatDetail(options) {
	return myRequery({
		url: 'api/report/exportplatformsalestatdetail',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/*导出配送员订单明细*/
export function exportDeliveryOrderDetail(options) {
	return myRequery({
		url: 'api/report/exportdeliveryorderdetail',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/********      外卖柜管理        ***********/
/*查询获取外卖柜列表
{
	area : '',
	cabcode: '',
	offset : 0,
	limit : 10
}
*/
export function queryCabinetsList(options) {
	return myRequery({
		url: 'api/takeawaycabinet',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/*添加外卖柜
{
	type : "self/mt",
	area : '',
	address : '',
	longitude : ,
	latitude : ,
	state : '',
	worktime : '',
	cabcode: '',
	cablayout : ''
}
*/
export function addCabinet(options) {
	return myRequery({
		url: 'api/takeawaycabinet',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/*修改外卖柜
{
	id : '',
	type : "self/mt",
	area : '',
	address : '',
	longitude : ,
	latitude : ,
	state : '',
	worktime : '',
	cabcode: '',
	cablayout : ''
}
*/
export function editCabinet(options) {
	return myRequery({
		url: 'api/takeawaycabinet',
		method: 'PUT',
		prefix: prefix,
		data: options,
	})
}

/*删除外卖柜
{
	ids : []
}
*/
export function deleteCabinet(options) {
	return myRequery({
		url: 'api/takeawaycabinet',
		method: 'DELETE',
		prefix: prefix,
		data: options,
	})
}

/*查询外卖柜详情
{
	id : ‘’
}
*/
export function queryDetailCabinet(options) {
	return myRequery({
		url: 'api/takeawaycabinet/detail',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/*根据外卖柜id查询柜号列表
{
	id : ''
}
*/
export function queryCabinetUnits(options) {
	return myRequery({
		url: 'api/takeawaycabinet/getcabinetunits',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/*添加柜号
{
	cabinetid : '',
	num : '',
	code : '',
	addr : '',
	state : '',
	havefood : '',
	usedstate : '',
	notes : ''
}
*/
export function addCabinetUnit(options) {
	return myRequery({
		url: 'api/cabinetunit',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/*编辑柜号
{
	id : '',
	cabinetid : '',
	num : '',
	code : '',
	addr : '',
	state : '',
	havefood : '',
	usedstate : '',
	notes : ''
}
*/
export function editCabinetUnit(options) {
	return myRequery({
		url: 'api/cabinetunit',
		method: 'PUT',
		prefix: prefix,
		data: options,
	})
}

/*获取柜号详情
{
	id : ''
}
*/
export function queryCabinetUnitDetail(options) {
	return myRequery({
		url: 'api/cabinetunit/detail',
		method: 'PUT',
		prefix: prefix,
		data: options,
	})
}

/*删除柜号
{
	id : []
}
*/
export function deleteCabinetUnit(options) {
	return myRequery({
		url: 'api/cabinetunit',
		method: 'DELETE',
		prefix: prefix,
		data: options,
	})
}

/*人工开柜号
{
	id : ''
}
*/
export function openCabinetUnit(options) {
	return myRequery({
		url: 'api/cabinetunit/test',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}